import { render, staticRenderFns } from "./CorpGovernance.vue?vue&type=template&id=c114aa3a&scoped=true&"
import script from "./CorpGovernance.vue?vue&type=script&lang=js&"
export * from "./CorpGovernance.vue?vue&type=script&lang=js&"
import style0 from "./CorpGovernance.vue?vue&type=style&index=0&id=c114aa3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c114aa3a",
  null
  
)

export default component.exports